module.exports = __webpack_public_path__ + "static/media/recipe.6b2e8638.jpg";